<template>

  <div class="layout__padding-clear layout__width-80">
    <div class="layout__position-left layout__width-100">
      <CustomerOrdersSearch
        :searchParams="searchParams"
        :orders="orders"
        :view="view"
        :loading="loading"
      />
    </div>

    <el-table
      :data="orders"
      v-on:row-click="showOrderDetails"
      class="layout__height-600px layout__scrolling__right layout__margin__bottom-30"
      v-loading="loading"
    >
      <el-table-column
        prop="orderId"
        label="Order Id"
      />
      <el-table-column
        prop="billDescription"
        label="Order Ref"
        :formatter="formatOrderRef"
      />
      <el-table-column
        prop="status"
        label="Status"
      />
      <el-table-column
        prop="customerRef"
        label="Customer Ref"
      />
      <el-table-column
        prop="ordered"
        label="Created"
        :formatter="formatDateDDMMYYYY"
      />
      <el-table-column
        prop="quantity"
        label="Qty"
      />
      <el-table-column
        prop="billGrossTotal"
        label="Cost (GBP)"
        :formatter="returnCurrency"
      />
      <el-table-column label="Download Artwork">
        <template slot-scope="props">
          <div
            v-if="props.row && props.row.jobFilename"
            class="layout__padding-clear"
          >
            <img
              class="layout__width-20px layout__position-center"
              src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/download.png"
              alt=""
              @click="downloadPdf(props.row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="layout__padding-clear layout__width-60">
      <div class="layout__padding-20-0">
        <el-pagination
          class="layout__padding-clear"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="this.searchParams.currentPage"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="this.searchParams.pagination"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.resultsCount"
        />
      </div>
    </div>

  </div>

</template>

<script>
import Axios from 'axios';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';
import CustomerOrdersSearch from '../../components/search/CustomerOrdersSearch';
import Pagination from '../../components/Pagination';
import { pagination } from '@/mixins/Pagination.js';

export default {
  name: 'OrderDetails',

  mixins: [axios, csvDownloadHelper, dataFormatter, pagination],

  components: {
    Pagination,
    CustomerOrdersSearch
  },

  props: ['id'],

  data() {
    return {
      adminDisabled: true,
      role: '',
      download: false,
      jobStatus: null,
      loading: false,
      orders: [],
      searchParams: {},
      view: 'IMA',
      resultsCount: 0,
    };
  },

  created() {
    console.log('DIRECTMAILR');
    // console.log(this.returnCookie("_customer"))
    if (typeof this.returnCookie('_token') === 'undefined') {
      let parameters = window.location.search.split('=');

      console.log(parameters[1]);

      if (parameters[1]) {
        const getCurrentLoginContext = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Session/GetCurrentLoginContext`;

        Axios.get(getCurrentLoginContext,
          this.returnHeaderUsingParameter(parameters[1]))

          .then(response => {
            this.persistUserSessionUsingParameter(parameters[1], response);
            console.log('finished persisting the cookies');
            // EventBus.$emit('customerSearch', this.returnHeaderUsingToken())
            // EventBus.$emit('update', this.returnAllCookies())
          });
      }
    } else {
      this.role = JSON.parse(this.returnCookie('_role'));
    }
  },

  mounted() {
    console.log('mounted');

    document.getElementById('getCustomerOrders').classList.add('is-disabled');
  },

  beforeDestroy() {
    console.log('beforeDestroy');

    if (document.getElementById('getCustomerOrders') !== null) {
      document.getElementById('getCustomerOrders').classList.remove('is-disabled');
    }
  },

  methods: {
    showOrderDetails(job) {
      console.log('job id ' + job.sourceId);
      console.log(job);
      this.$router.push({
        name: '/orders/directmailr/details',
        params: {
          orderOverview: job
        },
        query: {
          id: job.sourceId,
        }
      });
    },

    stopPropagation() {
      event.stopPropagation();
    },

    downloadOriginalJobBag(job) {
      const download = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + job.sourceId + '/download';
      this.downloadLink(event, download);
      event.stopPropagation();
    },

    downloadCompletedOrder(job) {
      const downloadComplete = `${process.env.VUE_APP_PHOTOFIXRAPIHOST}/api/v1/photofixr/jobs/` + job.sourceId + '/DownloadCompleted';
      this.downloadLink(event, downloadComplete);
      event.stopPropagation();
    },

    resultsPerPage() {
      document.getElementById('getCustomerOrdersPagination').click();
    },

    downloadPdf(artwork) {
      const { jobFilename } = artwork;

      event.stopPropagation();

      const link = document.createElement('a');

      link.href = jobFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      event.stopPropagation();
    },
  }
};
</script>